// Component: Tabs
// Author: Neha
import React, { useEffect } from 'react';
import { Text, RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import TabsNPM, { TabContainer, Tab, TabPanel } from '@rotaryintl/harris-tabs';
import Accordion from '../Accordion';

const Tabs = (props) => {
  const tabItems = props.fields?.children;

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const style = document.createElement('style');
    style.innerHTML = `
    p{ margin-bottom : 0px; }
    .rwc-col-layout__title{ 
      margin-bottom : 0px !important;
      font-size: 38px !important;
      line-height: 45px !important;
      font-weight: 600 !important;
      word-wrap: break-word;
      overflow-wrap: break-word;
      hyphens: manual;
    }
    .rwc-col-layout__col>:not([hidden])~:not([hidden]) {
      margin-top: calc(2rem*(1 - var(--tw-space-y-reverse))); }
    .rwc-col-layout { row-gap: 12px; }

    .rwc-vendors-card__meta-row {
      display: flex;
      align-items: flex-start !important;
    }
    
    .rwc-vendors-card__meta-text a {
      font-weight: 700 !important;
    }
    
    @media (min-width: 768px) {
      .rwc-col-layout__title {
        max-width: none;
        font-size: 48px !important;
        line-height: 57px !important;
        font-weight: 600 !important;
      }
    }

    @media (min-width: 1024px) {
      .rwc-col-layout__title {
        font-size: 58px !important;
        line-height: 70px !important;
        font-weight: 600 !important;
      }
    }`;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <TabsNPM initialTab={0}>
      {/* Tab labels */}
      <TabContainer>
        {tabItems.map((item, index) => (
          <Tab key={item.id} index={index} disabled={item.fields?.Disabled?.value}>
            <Text field={item.fields?.Title} />
          </Tab>
        ))}
      </TabContainer>

      {/* Tab content */}
      {tabItems.map((item, index) => (
        <TabPanel key={item.id} index={index}>
          <RichText style={{ fontSize: '24px', fontWeight: '600', lineHeight: '36px' }} field={item.fields?.Content} />
          {/* Render all accordions under this tab */}
          {Array.isArray(item.fields?.children) && item.fields.children.map((child) => <Accordion key={child.id} fields={child.fields} />)}
        </TabPanel>
      ))}
    </TabsNPM>
  );
};

export default withSitecoreContext()(Tabs);
